import { render, staticRenderFns } from "./F10Manager.vue?vue&type=template&id=496bc4d4"
import script from "./F10Manager.vue?vue&type=script&lang=js"
export * from "./F10Manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports